import { applyRules } from '@/rules';
import { RulesSchema } from '@/rules';
import { CampaignAudienceType, Campaign } from '@/models';

export const campaignMessageTokenRules = {
  attr: {
    name: [
      (v: any) => !!v || 'obrigatório',
    ],
    value: [
      (v: any) => !!v || 'obrigatório',
    ],
  },
};

export const audienceCustomerListRules = {
  attr: {
    phoneCountryCode: [
      (v: any) => !!v || 'obrigatório',
      (v: any) => v.length === 3 || v.length === 2 || 'Inválido',
    ],
    phoneAreaCode: [
      (v: any) => !!v || 'obrigatório',
      (v: any) => v.length === 3 || v.length === 2 || 'Inválido',
    ],
    phoneNumber: [
      (v: any) => !!v || 'obrigatório',
      (v: any) => v.length === 9 || 'Inválido',
    ],
    tokens: campaignMessageTokenRules,
  },
};

export const audienceFileRules = {
  rules: [(v: any) => !!v || 'faça o upload de um arquivo'],
  schema: {
    attr: {},
  },
};

export const audienceFileTokenRules = {
  attr: {
    fileColumn: [(v: any) => !!v || 'obrigatório'],
    token: [(v: any) => !!v || 'obrigatório'],
  },
};

export const scheduledToRules = {
  attr: {
    iso: [
      (v: any) => !!v || 'obrigatório',
    ],
  },
};

export const rateLimitRules = {
  attr: {
    volume: [
      (v: any) => v !== null && v !== undefined || 'obrigatório',
      (v: any) => v > 0 || 'Inválida',
    ],
    unit: [
      (v: any) => v !== null && v !== undefined || 'obrigatório',
      (v: any) => v === 'HOUR' || v === 'DAY' || 'Inválido',
    ],
  },
};

export const routeRepliesRules = {
  attr: {
    untilDate: [
      (v: any) => !!v || 'obrigatória',
      (v: any) => v > 0 && v < 4 || 'inválida',
    ],
    objectId: [
      (v: any) => !!v || 'obrigatório',
    ],
  },
};

export const campaignRules: RulesSchema = {
  attr: {
    title: [(v: any) => !!v || 'obrigatório'],
    textMessage: [(v: any) => !!v || 'obrigatória'],
    audienceFile: audienceFileRules,
    audienceCustomerList: {
      rules: [(v: any) => v && v.length > 0 || 'precisa ter ao menos 1 elemento'],
      schema: audienceCustomerListRules,
    },
    audienceFileTokenMapping: audienceFileTokenRules,
    rateLimit: rateLimitRules,
    scheduledTo: scheduledToRules,
    routeReplies: routeRepliesRules,
  },
};

export const validateCampaign = (campaign: Campaign) => {
  return applyRules(campaign, campaignRules, [
    'title', 'textMessage', ...[
      ...campaign.scheduledTo ? ['scheduledTo'] : [],
      ...campaign.rateLimit ? ['rateLimit'] : [],
      ...campaign.routeReplies ? ['routeReplies'] : [],
      ...campaign.audienceType === CampaignAudienceType.File && ['audienceFile', 'audienceFileTokenMapping'] || [],
      ...campaign.audienceType === CampaignAudienceType.List && ['audienceCustomerList'] || [],
    ],
  ]);
};

export const validateCampaignSteps = (campaign: Campaign) => {
  const basicInfoErrorMessage = applyRules(campaign, campaignRules, ['title', 'textMessage']) as any;
  const audienceErrorMessage = applyRules(
    campaign, campaignRules,
    [
      ...(campaign.audienceType === CampaignAudienceType.File) && ['audienceFile', 'audienceFileTokenMapping'] || [],
      ...(campaign.audienceType === CampaignAudienceType.List) && ['audienceCustomerList'] || [],
    ],
  ) as any;
  const scheduleErrorMessage = applyRules(
    campaign, campaignRules,
    [
      ...campaign.scheduledTo ? ['scheduledTo'] : [],
      ...campaign.rateLimit ? ['rateLimit'] : [],
    ],
  ) as any;
  const replyErrorMessage = applyRules(
    campaign, campaignRules,
    [
      ...campaign.routeReplies ? ['routeReplies'] : [],
    ],
  ) as any;
  return {
    basicInfoErrorMessage,
    audienceErrorMessage,
    scheduleErrorMessage,
    replyErrorMessage,
  };
};
